/**
 * Created by andrey on 08.05.2020
 */

cleverapps.UI.Avatar = cc.Node.extend({
    ctor: function (player, options) {
        options = options || {};

        let image = player;
        let userId = options.userId;

        if (player && (player.avatar || player.id)) {
            image = player.avatar;
            userId = player.id;
        }

        this._super();

        const isPlayer = userId === connector.platform.getUserID()
            || (typeof Competition !== "undefined" && userId === Competition.PLAYER_ID);

        if (isPlayer) {
            image = cleverapps.settings.getAvatar() || image;
        }

        this.setAnchorPoint(0.5, 0.5);

        this.useBigImage = options.useBigImage;
        this.padding = cc.padding(typeof options.padding !== "undefined" ? options.padding : cleverapps.styles.UI.Avatar);

        this.rounded = options.rounded;

        const useFrame = this.useFrame = options.useFrame !== false;
        if (useFrame) {
            let frameImage = options.frame;
            if (!frameImage) {
                frameImage = isPlayer ? bundles.avatar.frames.avatar_frame2 : bundles.avatar.frames.avatar_frame;
            }
            const frame = new cc.Sprite(frameImage);
            frame.setLocalZOrder(1);
            this.addChild(frame);

            this.setContentSize2(frame.getContentSize());
            frame.setAlignment(this.width / 2, this.height / 2);
        }

        let defaultImage = options.defaultImage;
        if (!defaultImage) {
            const images = cleverapps.UI.Avatar.GetAvatarFramesNames();

            if (isPlayer) {
                defaultImage = bundles.avatars.frames[`${images[0]}${this.useBigImage && "_big" || ""}`];
            } else {
                const pseudo = PseudoRandom.GET("avatar");
                pseudo.seed(userId || String(image));
                defaultImage = bundles.avatars.frames[`${pseudo.choose(images)}${this.useBigImage && "_big" || ""}`];
            }
        }

        const avatar = new cc.Sprite(defaultImage);

        if (!useFrame || options.bg) {
            this.setContentSize2(options.size || cc.rectAddPadding(avatar, this.padding));
        }

        if (options.bg) {
            const bg = this.bg = cleverapps.UI.createScale9Sprite(options.bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
            bg.setContentSize2(this.getContentSize());
            bg.setAlignment(this.width / 2, this.height / 2);
            this.addChild(bg);
        }

        if (options.foreground) {
            const foreground = this.foreground = new cc.Sprite(options.foreground);
            foreground.setLocalZOrder(2);
            this.addChild(foreground);
        }

        this.addChild(avatar);
        this.avatar = avatar;

        this.adjustSize();

        this.image = image;

        if (!image && userId && !isPlayer) {
            cleverapps.RestClient.get(`/info/user/${encodeURIComponent(userId)}`, {}, (response) => {
                this.image = response.avatar;
                this.setImage(this.image);
            });
        }

        this.onImageLoadListener = this.createListener(this.onImageLoad.bind(this));
    },

    showBg: function () {
        if (this.bg) {
            this.bg.setVisible(true);
        }
    },

    hideBg: function () {
        if (this.bg) {
            this.bg.setVisible(false);
        }
    },

    onEnter: function () {
        this._super();

        if (this.image) {
            let isGood = true;
            ["stub_128x128.gif", "camera_200.png"].forEach((bad) => {
                if (typeof this.image === "string" && this.image.indexOf(bad) !== -1) {
                    isGood = false;
                }
            });

            if (isGood) {
                this.setImage(this.image);
            }
        }
    },

    adjustSize: function () {
        this.avatar.setAlignment(this.width / 2 + (this.padding.left - this.padding.right) / 2, this.height / 2 + (this.padding.bottom - this.padding.top) / 2);
        this.avatar.setScale((this.width - this.padding.left - this.padding.right) / this.avatar.width, (this.height - this.padding.top - this.padding.bottom) / this.avatar.height);

        if (this.foreground) {
            this.foreground.setAlignment(this.avatar.x, this.avatar.y);
            this.foreground.setScale(1.02 * this.avatar.width * this.avatar.scaleX / this.foreground.width, 1.02 * this.avatar.height * this.avatar.scaleY / this.foreground.height);
        }
    },

    onImageLoad: function (code, data) {
        if (!code) {
            try {
                const newAvatar = new cc.Sprite(this.prepareImage(data));

                this.avatar.removeFromParent();
                this.addChild(newAvatar);

                this.avatar = newAvatar;
                this.adjustSize();
            } catch (e) {
                console.log("Cross-domain??", e);
            }
        } else {
            console.log("Error loading avatar image!");
        }
    },

    loadGif: function (url) {
        if (!connector.info.isNative) {
            url = url.replace("https:", "").replace("http:", "");
        }

        if (url === this.imageUrl) {
            return;
        }
        this.imageUrl = url;
        try {
            const gif = new SuperGif({ auto_play: false });
            gif.load_url(url, this.createListener(() => {
                if (url !== this.imageUrl) {
                    return;
                }

                const framesData = gif.getFrames();

                if (Array.isArray(framesData) && framesData.length > 0) {
                    const newAvatar = new cc.Sprite(this.prepareImage(framesData[0]));
                    newAvatar.setAlignment(this.width / 2, this.height / 2);

                    this.avatar.removeFromParent();
                    this.addChild(newAvatar);

                    this.avatar = newAvatar;
                    this.adjustSize();

                    const frames = [];
                    framesData.forEach((frameData) => {
                        frames.push(new cc.Sprite(this.prepareImage(frameData)).getSpriteFrame());
                    });

                    this.avatar.runAction(new cc.RepeatForever(new cc.Animate(frames, 0.075)));
                }
            }));
        } catch (e) {
            if (url === this.imageUrl) {
                delete this.imageUrl;
            }
            console.log("Cross-domain??", e);
        }
    },

    prepareImage: function (image) {
        return this.rounded && cleverapps.UI.Avatar.IsExternal(this.image) ? cleverapps.UI.Avatar.RoundCorners(image) : image;
    },

    setImage: function (image) {
        if (!image) {
            return;
        }

        if (cleverapps.UI.Avatar.IsExternal(image) && connector.platform.oneOf(connector.REDDIT)) {
            return;
        }

        if (image instanceof SpriteFrame) {
            this.avatar.setSpriteFrame(image);
            this.adjustSize();
        } else if (typeof image !== "string") {
            console.log("avatar", image);
            cleverapps.throwAsync(`avatar image type error ${typeof image}`);
        } else if (image.startsWith("#") || image.startsWith("@")) {
            const parts = image
                .replace("#", "")
                .replace("@", "")
                .replace(".png", "")
                .split("/");

            const bundle = bundles[parts[0]];
            if (bundle) {
                this.setImage(this.useBigImage && bundle.frames[`${parts[1]}_big`] || bundle.frames[parts[1]]);
            }
        } else if (image.indexOf(".gif") !== -1) {
            this.loadGif(image);
        } else {
            image = decodeURIComponent(image);

            if (cleverapps.UI.Avatar.isExpiredFacebookPhoto(image)) {
                return;
            }

            const data = cleverapps.UI.Avatar.cache.get(image);
            if (data) {
                this.onImageLoadListener(0, data);
                return;
            }

            // if (config && config.debugMode) console.log("Starting to load: " + image);
            cc.loader.loadImg(image, (code, data) => {
                // if (config && config.debugMode) console.log("Finished loading: " + image);
                this.onImageLoadListener(code, data);
            });
        }
    }
});

cleverapps.UI.Avatar.GetAvatarFramesNames = function () {
    return Object.keys(bundles.avatars.frames).filter((key) => key.startsWith("avatar_") && !key.endsWith("_big"));
};

cleverapps.UI.Avatar.cache = new cleverapps.Cache();

cleverapps.UI.Avatar.preload = function (avatar, callback) {
    callback = callback || function () { };

    if (Array.isArray(avatar)) {
        const waiter = cleverapps.wait(avatar.length, callback);
        avatar.forEach((single) => {
            cleverapps.UI.Avatar.preload(single.avatar || single, waiter);
        });
        return;
    }

    if (typeof avatar !== "string" || avatar.indexOf("#") === 0 || avatar.indexOf(".gif") !== -1) {
        callback();
        return;
    }

    avatar = decodeURIComponent(avatar);

    if (cleverapps.UI.Avatar.isExpiredFacebookPhoto(avatar)) {
        callback();
        return;
    }

    const data = cleverapps.UI.Avatar.cache.get(avatar);
    if (data) {
        callback(data);
        return;
    }

    cc.loader.loadImg(avatar, (code, data) => {
        if (!code) {
            cleverapps.UI.Avatar.cache.set(avatar, data);
        }
        callback(!code && data);
    });
};

cleverapps.UI.Avatar.isExpiredFacebookPhoto = function (image) {
    if (image.indexOf("platform-lookaside.fbsbx.com") === -1) {
        return false;
    }

    const ext = new URLSearchParams(image.split("?")[1] || "").get("ext");
    return Boolean(ext) && Number(ext) * 1000 < Date.now();
};

// rounded once on load, a rounding shader would break the sprite batch on every avatar
cleverapps.UI.Avatar.RoundCorners = function (image) {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;

    const ctx = canvas.getContext("2d");
    ctx.save();
    ctx.scale(canvas.width, canvas.height);
    ctx.beginPath();
    ctx.moveTo(0.5, 0);
    ctx.arcTo(1, 0, 1, 1, cleverapps.UI.Avatar.CORNER_RADIUS);
    ctx.arcTo(1, 1, 0, 1, cleverapps.UI.Avatar.CORNER_RADIUS);
    ctx.arcTo(0, 1, 0, 0, cleverapps.UI.Avatar.CORNER_RADIUS);
    ctx.arcTo(0, 0, 1, 0, cleverapps.UI.Avatar.CORNER_RADIUS);
    ctx.closePath();
    ctx.restore();

    ctx.clip();
    ctx.drawImage(image, 0, 0);

    return canvas;
};

cleverapps.UI.Avatar.CORNER_RADIUS = 0.25;

cleverapps.UI.Avatar.IsExternal = function (image) {
    return typeof image === "string" && image.startsWith("http");
};